import { programConfig } from '@/config';

export const formatPhone = (phoneNumber: string | undefined) => {
  if (!phoneNumber) return '';

  const cleaned = phoneNumber.replace(/\D/g, '');

  if (cleaned.length !== 10) {
    return 'Invalid phone number';
  }

  return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
};

export const getManufacturerByProgram = (program: string) => {
  const lowercaseProgram = program && program.toLowerCase();
  const config = programConfig.find((item) => item.Program.toLowerCase() === lowercaseProgram);
  return config ? config.Manufacturer : null;
};

export const isOctaPharmaProgram = (programName: string) => {
  return getManufacturerByProgram(programName)?.indexOf('Octapharma') !== -1;
};

export const getProgramNameByDomain = () => {
  const domain = typeof window !== 'undefined' ? window.location.hostname : '';

  const hostname = domain.startsWith('http') ? new URL(domain).hostname : domain;

  let subdomain = hostname.split(/[.-]/)[0];

  if (subdomain.startsWith('my')) {
    subdomain = subdomain.replace('my', '');
  }

  if (subdomain === 'factorforhealth') {
    return 'alphanine';
  } else if (subdomain === 'gamunex-c') {
    return 'gamunex';
  }

  return subdomain.toLowerCase();
};
